import React from 'react';
import styled from 'styled-components';
import html2canvas from 'html2canvas';

interface SaveAsImageButtonProps {
  targetRef?: React.RefObject<HTMLElement | null>;
  fileName?: string;
  label?: string;
}

function makeExpandedClone(target: HTMLElement) {
  const clone = target.cloneNode(true) as HTMLElement;

  // 화면 밖에 위치시키기 (visibility:hidden은 html2canvas가 무시할 수 있어 offscreen 권장)
  Object.assign(clone.style, {
    position: 'fixed',
    left: '-99999px',
    top: '0',
    zIndex: '-1',
    width: 'auto',
    maxWidth: 'unset',
  } as CSSStyleDeclaration);

  // 복제본을 DOM에 붙여야 scrollWidth/이미지 로딩 등이 정상 작동
  document.body.appendChild(clone);

  // 스크롤 해제 + 내부 폭 강제 (우리가 달아둔 data-attr 기준)
  const expanders = clone.querySelectorAll('[data-export-expand]');
  expanders.forEach((pane) => {
    const el = pane as HTMLElement;
    const inner = el.querySelector('[data-export-inner]') as HTMLElement | null;
    el.style.overflowX = 'visible';
    const contentWidth = inner?.scrollWidth ?? el.scrollWidth;
    el.style.width = `${contentWidth}px`;
  });

  // 루트 폭도 콘텐츠 전체로
  const root = clone.querySelector('[data-capture-root]') as HTMLElement | null;
  if (root) {
    root.style.maxWidth = 'unset';
    root.style.width = `${root.scrollWidth}px`;
  }

  // 최종 캡처 크기
  const captureWidth = clone.scrollWidth;
  const captureHeight = clone.scrollHeight;

  return {
    clone,
    captureWidth,
    captureHeight,
    cleanup() {
      clone.remove();
    },
  };
}

const SaveAsImageButton: React.FC<SaveAsImageButtonProps> = ({
  targetRef,
  fileName = 'screenshot.png',
  label,
}) => {
  const handleSave = async () => {
    if (!targetRef || !targetRef.current) return;

    const { clone, captureWidth, captureHeight, cleanup } = makeExpandedClone(
      targetRef.current,
    );

    try {
      // 2) 복제본을 기준으로 캡처 (옵션은 복제본 크기 사용)
      const canvas = await html2canvas(clone, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        width: captureWidth,
        height: captureHeight,
        windowWidth: captureWidth,
        windowHeight: captureHeight,
        scrollX: 0,
        scrollY: 0,
      });

      const a = document.createElement('a');
      a.href = canvas.toDataURL('image/png');
      a.download = fileName;
      a.click();
    } finally {
      // 3) 정리
      cleanup();
    }
  };

  //   try {
  //     const canvas = await html2canvas(targetRef.current, {
  //       scale: 2,
  //       useCORS: true,
  //       backgroundColor: '#ffffff',
  //     });

  //     const link = document.createElement('a');
  //     link.href = canvas.toDataURL('image/png');
  //     link.download = fileName;
  //     link.click();
  //   } catch (err) {
  //     console.error('이미지 저장 중 오류:', err);
  //   }
  // };

  return (
    <Button onClick={handleSave} className="flex items-center gap-2">
      <img src="/assets/images/icon/image_icon.svg" />
      {label}
    </Button>
  );
};

export default SaveAsImageButton;

const Button = styled.div`
  display: flex;
  width: 36px;
  height: 36px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--npl-semantic-line-light-02, #e8e9ed);
  background: var(--npl-semantic-background-solid-light-00, #fff);
`;
